'use client';

import { useState } from 'react';
import Image from 'next/image';
import { LogoutLink } from '~/components/logout-link';

type HeaderProps = {
  unreadMessageCount: number;
  unreadScoutCount: number;
  unreadAllCount: number;
};

export const SPHeaderSignedIn = (props: HeaderProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [menuText, setMenuText] = useState('メニュー');
  const toggle = () => {
    setIsOpen(!isOpen);
    setMenuText(isOpen ? 'メニュー' : '閉じる');
  };

  return (
    <>
      <div className="l-header -base md:hidden">
        <div className="l-header-container">
          <div className="u-flex -justify-between u-gap10 l-header__icon-wrapper">
            <a
              href="/mypage/favorites?ref=top-sp-header"
              className="l-header__icon"
            >
              <Image
                alt="お気に入りアイコン"
                src="/nextjs/images/icons/ic_heart_outline_green.svg"
                width="18"
                height="18"
                className="h-[20px]"
              />
              <div className="l-header__icon-text">お気に入り</div>
            </a>
            <a href="/jobs?ref=top-sp-header" className="l-header__icon">
              <Image
                alt="虫眼鏡アイコン"
                src="/nextjs/images/icons/ic_magnifying-glass.svg"
                width="20"
                height="20"
              />
              <div className="l-header__icon-text">求人検索</div>
            </a>
          </div>
          <div className="l-header__image -center">
            <a href="/">
              <Image
                alt="ロゴ"
                src="/nextjs/images/logo/logo.webp"
                width="160"
                height="40"
              />
            </a>
          </div>
          <div
            className={`l-header__sp-hamburger u-w43 ${isOpen && '-open'}`}
          ></div>
          <div className="u-flex -items-center -justify-center">
            <a href="/mypage/messages" className="l-header__icon u-pr10">
              <div className="u-pos-rel">
                <Image
                  alt="メールアイコン"
                  src="/nextjs/images/icons/ic_mail_2.png"
                  width="18"
                  height="18"
                />
                {props.unreadAllCount > 0 && (
                  <span className="c-unread-label -circle -sp">
                    {props.unreadAllCount}
                  </span>
                )}
              </div>
              <div className="l-header__icon-text u-font-normal">
                メッセージ
              </div>
            </a>
            <div className="c-hamburger__icon-wrapper" onClick={() => toggle()}>
              <div
                className={`c-hamburger__icon u-mb2 ${isOpen && '-open'}`}
              ></div>
              <div className="l-header__icon-text">{menuText}</div>
            </div>
          </div>
        </div>
      </div>
      <SPDrawer isOpen={isOpen} />
    </>
  );
};

type SPDrawerProps = {
  isOpen: Boolean;
};
const SPDrawer = (props: SPDrawerProps) => {
  return (
    <div className="c-hamburger">
      <nav className={`c-hamburger__menu ${props.isOpen && '-open'}`}>
        <div className="u-pt10 u-px20 u-w-full">
          <div className="c-hamburger__item -border-with-radius u-bg-white u-p1 u-mt10">
            <a
              href="/jobs?ref=sp-menu-search-signedin"
              className="c-hamburger__link -arrow-right"
            >
              <Image
                alt="虫眼鏡アイコン"
                src="/nextjs/images/icons/ic_magnifying_glass.png"
                width="20"
                height="20"
              />
              <p className="u-ml11">求人を探す</p>
            </a>
          </div>
          <div>
            <div className="c-hamburger__item -list-border u-bg-white u-p1 u-mt10">
              <a
                href="/mypage?ref=sp-menu-mypage-signedin"
                className="c-hamburger__link -arrow-right"
              >
                <Image
                  alt="ユーザーアイコン"
                  src="/nextjs/images/icons/ic_user.png"
                  width="20"
                  height="20"
                />
                <p className="u-ml11">マイページ</p>
              </a>
            </div>
            <div className="c-hamburger__item -list-border u-bg-white u-p1">
              <a
                href="/mypage/histories?ref=sp-menu-history-signedin"
                className="c-hamburger__link -arrow-right"
              >
                <Image
                  alt="閲覧履歴アイコン"
                  src="/nextjs/images/icons/ic_clock_outline_green.png"
                  width="20"
                  height="20"
                />
                <p className="u-ml11">閲覧履歴</p>
              </a>
            </div>
            <div className="c-hamburger__item -list-border u-bg-white u-p1">
              <a
                href="/mypage/jobs?ref=sp-menu-applied-signedin"
                className="c-hamburger__link -arrow-right"
              >
                <Image
                  alt="応募中の求人一覧アイコン"
                  src="/nextjs/images/icons/ic_applied_jobs.svg"
                  width="20"
                  height="20"
                />
                <p className="u-ml11">応募中の求人一覧</p>
              </a>
            </div>
            <div className="c-hamburger__item -list-border u-bg-white u-p1">
              <a
                href="/mypage/interview_schedule?ref=sp-menu-interview-signedin"
                className="c-hamburger__link -arrow-right"
              >
                <Image
                  alt="面接日程アイコン"
                  src="/nextjs/images/icons/ic_calendar.png"
                  width="20"
                  height="20"
                />
                <p className="u-ml11">面接日程</p>
              </a>
            </div>
            <div className="c-hamburger__item -list-border u-bg-white u-p1">
              <a
                href="/mypage/resume?ref=sp-menu-resume-signedin"
                className="c-hamburger__link -arrow-right"
              >
                <Image
                  alt="Web履歴書アイコン"
                  src="/nextjs/images/icons/ic_report.png"
                  width="20"
                  height="20"
                />
                <p className="u-ml11">Web履歴書</p>
              </a>
            </div>
            <div className="c-hamburger__item -list-border u-bg-white u-p1">
              <a
                href="/examdk?ref=sp-menu-exam-signedin"
                className="c-hamburger__link -arrow-right"
              >
                <Image
                  alt="電気工事士試験問題アイコン"
                  src="/nextjs/images/icons/ic_exam.svg"
                  width="20"
                  height="20"
                />
                <p className="u-ml11">電気工事士試験問題</p>
              </a>
            </div>
            <div className="c-hamburger__item -list-border u-bg-white u-p1">
              <a
                href="/mypage/settings/edit?ref=sp-menu-settings-signedin"
                className="c-hamburger__link -arrow-right"
              >
                <Image
                  alt="各種設定アイコン"
                  src="/nextjs/images/icons/ic_config.png"
                  width="20"
                  height="20"
                />
                <p className="u-ml11">各種設定</p>
              </a>
            </div>
          </div>
          <div className="c-hamburger__item -border-with-radius u-bg-white u-p1 u-mt10">
            <LogoutLink>ログアウト</LogoutLink>
          </div>
        </div>
      </nav>
    </div>
  );
};
